<script>
  import {createEventDispatcher, onDestroy} from 'svelte';
  import {fade} from 'svelte/transition';
  import {IMAGES_NEWS} from '@/const/images';

  const dispatch = createEventDispatcher();

  let className = '';
  export {className as class};
  export let style = '';
  export let visible = false;
  export let size = 'normal';
  export let showCloseIcon = false;
  export let showCloseIcon2 = false;
  export let customContent = false;
  export let allowScroll = false;

  let scrollWidth = 1200;

  $: process.browser && updateBody(visible);

  onDestroy(() => process.browser && updateBody());

  function updateBody(visible) {
    if (visible && !allowScroll) {
      document.body.style.overflow = 'hidden';
      return;
    }
    document.body.style.overflow = 'auto';
  }

  function handleModalClose() {
    dispatch('close');
  }
</script>

<style>
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }
  .container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal {
    position: relative;
    border-radius: 12px;
    width: 520px;
    max-height: calc(100vh - 3em);
    background: #fff;
    overflow: auto;
  }
  .modal.big {
    width: 620px;
  }
  .modal.middle {
    width: 480px;
  }
  .modal.small {
    width: 320px;
  }
  .modal.phone {
    width: calc(100vw - 3em);
  }
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  .close-icon-wrap {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1;
    width: 40px;
    height: 40px;
  }
  .close-icon-wrap .close-icon {
    position: static;
  }
  .close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
  }
  @media screen and (max-width: 640px) {
    .xs\:ph16 {
      padding-right: 16px;
      padding-left: 16px;
    }
  }
</style>

<svelte:window bind:innerWidth={scrollWidth} />
<div class={className}>
  <div class="modal-mask" on:click={() => dispatch('maskClick')} in:fade={{duration: 100}} out:fade={{duration: 100}}>
    <div class="container">
      <div
        class="modal
        sv"
        class:small={size === 'small'}
        class:middle={size === 'middle'}
        class:big={size === 'big'}
        class:phone={scrollWidth < 640}
        {style}
        in:fade={{duration: 100}}
        out:fade={{duration: 100}}
      >
        {#if showCloseIcon}
          <div class="close-icon-wrap df jcfe cp">
            <i class="close-icon iconfont f20 fw3 T4 cp" on:click={handleModalClose}>&#xe614;</i>
          </div>
        {/if}
        {#if showCloseIcon2}
          <div class="close-icon-wrap df jcfe cp">
            <img class="close-icon cp" on:click={handleModalClose} src={IMAGES_NEWS.CLOSE_ICON} width="22" height="22" alt="close icon" />
          </div>
        {/if}
        <div class="modal-body {customContent ? 'df' : 'p24 xs:ph16'}">
          <slot name="header" />
          <slot />
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</div>
